<template>
  <div class="page-header flex-row" v-if="!smallScreen">
    <div class="d-none d-md-block title">{{ pageTitle }}</div>
    <div class="intercomSelector" v-if="hasIntercoms && route === 'cam-listNew'">
      <CButtonGroup>
      <CButton :color="store.mode === 'cameras' ? 'success' : 'secondary'" size="lg" @click="store.setMode('cameras')">
        Камеры
        <span class="mdi mdi-camera-iris"></span>
      </CButton>
      <CButton :color="store.mode === 'intercoms' ? 'success' : 'secondary'" size="lg" @click="store.setMode('intercoms')">
        Домофоны
        <span class="mdi mdi-doorbell-video"></span>
      </CButton>
      </CButtonGroup>
      </div>
    <div class="flex-shrink flex-row m-auto">
      <div
        v-if="
          route === 'cam' ||
          route === 'cam-archive' ||
          route === 'cam-archive-better' ||
          route === 'cam-archive-all-cams' ||
          route === 'cam-list' ||
          route === 'cam-listNew' ||
          route === 'cam-new' ||
          route === 'intercom-new' ||
          route === 'cam-favorites'
        "
        class="cam-menu"
      >
        <CButton color="success" class="mr-2" @click="togglePlayerMute" title="Звук">
          <span class="mdi" :class="playerVolumeIcon"></span>
        </CButton>

        <CButton v-if="!hideTimerButton" color="success" class="mr-2" @click="toggleShowTimer">
          <span v-if="!showTimer" class="mdi mdi-timer"></span>
          <span v-if="showTimer" class="mdi mdi-timer-off"></span>
        </CButton>

        <div
          v-if="route !== 'cam-list' && route !== 'cam-listNew'"
          class="show-name right-float"
          @click="back"
        >
          <CButton color="danger">
            <i class="mdi mdi-arrow-left-bold"></i> <span class="align-text-bottom"> Назад</span>
          </CButton>
        </div>
      </div>

      <div
        v-if="
          route === 'cam-list' ||
          route === 'cam-archive-all-cams' ||
          route === 'cam-favorites' ||
          route === 'cam-listNew'
        "
        class="flex-row ms-2"
      >
        <button v-if="route === 'cam-list' && isAdmin" class="btn-all-cams" @click="toAllCams">
          архив по всем камерам
        </button>

        <button class="btn-fullscreen" @click="onFullScreen" v-if="!fullScreen">
          <span class="mdi mdi-fullscreen"></span>
        </button>

        <div v-if="gridCam" class="d-none d-md-block grid-cam">
          <CDropdown
            color="secondary"
            id="dropdown-1"
            v-model="gridCam"
            class="m-md-2"
            style="margin: 0 !important"
          >
            <CDropdownToggle color="secondary">
              <span class="mdi mdi-grid mr-2"></span>
              <span class="mr-2">{{ gridCam + 'x' + gridCam }}</span>
            </CDropdownToggle>
            <CDropdownMenu>
              <CDropdownItem href="#" @click="gridCam = 3">
                <span class="mdi mdi-grid-large mdi-18px mr-2"></span>3 x 3
              </CDropdownItem>
              <CDropdownItem href="#" @click="gridCam = 4">
                <span class="mdi mdi-grid-large mdi-18px mr-2"></span>4 x 4
              </CDropdownItem>
              <CDropdownItem href="#" @click="gridCam = 5">
                <span class="mdi mdi-grid-large mdi-18px mr-2"></span>5 x 5
              </CDropdownItem>
              <CDropdownItem href="#" @click="gridCam = 6">
                <span class="mdi mdi-grid-large mdi-18px mr-2"></span>6 x 6
              </CDropdownItem>
            </CDropdownMenu>
          </CDropdown>
        </div>

        <div class="show-name mr-2" @click="toggleShowCamName">
          <CTooltip
            :content="showCamName ? 'Показать названия камер' : 'Убрать названия камер'"
            placement="left"
          >
            <template #toggler="{ on }">
              <CButton color="secondary" v-on="on">
                <span v-if="!showCamName" class="mdi mdi-cctv"></span>
                <span v-if="showCamName" class="mdi mdi-cctv-off"></span>
              </CButton>
            </template>
          </CTooltip>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useDefaultStore } from '@/store'
import { playerVolumeIcon, togglePlayerMute } from '@/services/player-audio'
import {
  CButton,
  CDropdown,
  CDropdownToggle,
  CDropdownMenu,
  CDropdownItem,
  CTooltip,
  CButtonGroup
} from '@coreui/bootstrap-vue'

defineProps(['hideTimerButton'])

const store = useDefaultStore()
const vueRoute = useRoute()
const router = useRouter()

const mode = computed({
  get: () => store.mode,
  set: (v) => store.setMode(v)
})
const route = computed(() => vueRoute.name)
const isAdmin = computed(() => store.isAdmin)
const pageTitle = computed(() => store.pageTitle)
const smallScreen = computed(() => store.smallScreen)
const hasIntercoms = computed(
  () => store.currentDivision?.intercomList && store.currentDivision.intercomList.length > 0
)
const gridCam = computed({
  get: () => store.gridCam,
  set: (v) => store.setGridCam(v)
})
const showTimer = computed({
  get: () => store.showTimer,
  set: (v) => store.setShowTimer(v)
})
const showCamName = computed({
  get: () => store.showCamName,
  set: (v) => store.setShowCamName(v)
})
const fullScreen = computed(() => store.fullScreen)

function toggleShowCamName() {
  store.toggleShowCamName()
}

function toggleShowTimer() {
  showTimer.value = !showTimer.value
}

function back() {
  router.go(-1)
}

function toAllCams() {
  router.push({
    name: 'cam-archive-all-cams',
    params: {
      division: vueRoute.params.division,
      all: true
    }
  })
}

function onFullScreen() {
  store.setFullScreen(true)
}
</script>

<style lang="stylus">
.btn-fullscreen {
  background: none;
  outline: none;
  padding: 0;
  border: none;
  font-size: 55px;
  color: #666;
  line-height: 1px;
  &:focus {
    outline: none;
  }
}
.intercomSelector {
  margin-top: 2px;
}
.btn-all-cams {
  background: none;
  outline: none;
  padding: 0;
  border: none;
  color: #666;
  font-size: 21px;

  &:hover {
    color #fff
  }
}

.bx-fullscreen {
  display: block;
}
</style>
